// extracted by mini-css-extract-plugin
export default {"pcDeviceListWrap":"Rld28C","tabletDeviceListWrap":"k8Dfgy","mobDeviceListWrap":"KoCW4c","mobDeviceListWrapFlex":"ZtkWEf"};